import { useAppState } from '../context/OmniboxJsonConverterContext';
import { FileInputModal, RenderResults, AddTemplateModal, RenameTemplateModal } from '../omnibox_json_converter';
import { loadSettings, loadTechniqueSettings, computeGlobalColumns, createDefaultSettings } from '../omnibox_json_converter/converterHelperFunctions';
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography
} from '@mui/material';



function OmniboxJsonConverterPage() {
  const {
    openColumnsDialog, handleOpenColumnsDialog, handleCloseColumnsDialog,
    inputFiles, setInputFiles, filesRef, setSelectedSetting,
    setColumnsExist, selectedColumns, 
    setSelectedColumns, setGlobalColumns,
    setDetectedTechnique, resetAppState,
    displayResults, setDisplayResults, 
  } = useAppState();

  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    resetAppState();
    const entries = [];
    for (const f of files) {
      const entry = {
        fileObj: f,
        fileName: f.name.replace(/\.json$/i, ''),
        parsed: null,
        headerColumns: null,
        rawColumns: null,
        parseError: null,
        csvUrl: null,
        status: 'pending',
        progress: 0,
      };

      try {
        const text = await f.text();
        entry.parsed = JSON.parse(text);
      } catch (err) {
        entry.parseError = 'JSON parse error:' + (err && err.message ? err.message : 'invlaid JSON');
        entry.status = 'error';
      }

      entries.push(entry);
    }

    const results = computeGlobalColumns(entries);

    if (results.colOrder.length > 0) {
      setColumnsExist(true);
    }

    setGlobalColumns(results.colOrder);
    // setSelectedColumns(results.colOrder);
    setInputFiles(results.files);
    setDetectedTechnique(results.detectedTechnique);

    if (!localStorage['omnibox_json_converter']) {
      createDefaultSettings();
    }

    const settings = loadTechniqueSettings(results.detectedTechnique);
    setSelectedSetting(settings['last_used']);
    setSelectedColumns(settings['templates'][results.detectedTechnique] || results.colOrder);

    handleOpenColumnsDialog();
  }

  return (
    <Box>
      <Typography variant='h4' fontWeight={700} sx={{ mb: 1 }}>
        Omnibox Json Converter
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
        Convert Omnibox JSON outputs to long-format CSV files.
      </Typography>

      <Paper
        sx={{
          p: 4,
          backgroundColor: 'background.paper'
        }}
      >
        <Stack direction='row' spacing={1.5} alignItems='center'>
          <Button variant='contained' component='label' sx={{ fontSize: '12px' }}>
            Convert
            <input type='file' ref={filesRef} accept='.json,application/json' multiple hidden onChange={handleFileChange} />
          </Button>
          {(inputFiles.length > 0) && (
            <Button variant='outlined' onClick={handleOpenColumnsDialog} sx={{ fontSize: '12px'}}>
              View Format Settings
            </Button>
          )}
        </Stack>

        <Stack direction='column' sx={{ mt: '2.5%' }}>
          {displayResults ? (
            <RenderResults />
          ) : (
            <Stack direction='column' spacing={1}>
              <Typography variant='h5'>
                Results
              </Typography>

              <Typography variant='body2' color='text.secondary'>
                No results yet. Use "Convert" to start.
              </Typography>
            </Stack>
          )
          }
        </Stack>
      </Paper>

      <FileInputModal />
      <AddTemplateModal />
      <RenameTemplateModal />

    </Box>
  )
}

export default OmniboxJsonConverterPage;